export const UTILIZATION_LABELS = {
  AVG: 'Avg. Utilization',
  CURRENT: 'Current Utilization',
};
